export default __webpack_public_path__ + "static/media/blue_users.fc3388cb.svg";